import { IconButton, Tooltip } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";
import { useColorMode } from "../../theme/ColorModeContext";

/** Animated dark / light mode switch. */
export default function ThemeToggle() {
  const { mode, toggleColorMode } = useColorMode();
  const isDark = mode === "dark";

  return (
    <Tooltip title={isDark ? "Light mode" : "Dark mode"}>
      <IconButton
        onClick={toggleColorMode}
        aria-label="Toggle color mode"
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
          width: 40,
          height: 40,
        }}
      >
        <AnimatePresence mode="wait" initial={false}>
          <motion.span
            key={mode}
            initial={{ rotate: -90, opacity: 0, scale: 0.5 }}
            animate={{ rotate: 0, opacity: 1, scale: 1 }}
            exit={{ rotate: 90, opacity: 0, scale: 0.5 }}
            transition={{ duration: 0.25 }}
            style={{ display: "inline-flex" }}
          >
            {isDark ? (
              <LightModeRoundedIcon fontSize="small" sx={{ color: "#fbbf24" }} />
            ) : (
              <DarkModeRoundedIcon fontSize="small" sx={{ color: "#4f7cff" }} />
            )}
          </motion.span>
        </AnimatePresence>
      </IconButton>
    </Tooltip>
  );
}
